'use client';

import ReactGA from 'react-ga4';

const GoogleAnalytics = ({ GA_TRACKING_ID }: { GA_TRACKING_ID: string }) => {
  ReactGA.initialize(GA_TRACKING_ID);
  return null;
};

export default GoogleAnalytics;
